//teste vinicius
import React from "react";

import { Route, Switch, Redirect } from "react-router-dom";

import AuthNavbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footer";

import Login from "views/Login";
import Cadastrar from "views/Login/Cadastrar";
import Senha from "views/Login/Senha";
import Redefinir from "views/Login/Redefinir";
import Bloqueio from "views/Login/Bloqueio";

class Pages extends React.Component {
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  render() {
    return (
      <>
        <AuthNavbar />
        <div className="wrapper wrapper-full-page" style={{ height: '100vh', overflow: 'auto' }}>
          <div className="full-page section-image">
            <Switch>
              <Route
                path="/painelwebgestor/auth/login"
                component={Login}
              />
              <Route
                path="/painelwebgestor/auth/cadastrar"
                component={Cadastrar}
              />
              <Route
                path="/painelwebgestor/auth/senha"
                component={Senha}
              />
              <Route
                path="/painelwebgestor/auth/redefinir"
                component={Redefinir}
              />
              <Route
                path="/painelwebgestor/auth/bloqueio"
                component={Bloqueio}
              />
              <Redirect to="/painelwebgestor/auth/login" />
            </Switch>
            <Footer fluid />
          </div>
        </div>
      </>
    );
  }
}

export default Pages;